import React, { useState, useEffect } from 'react';
import { ValidatorForm } from 'react-form-validator-core';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Input, Button } from '../../../Atoms';
import { ErrorIcon } from '../../../Assets';
import { Logo } from '../../../Assets';
import { StepIndicator } from '../../../components';
import { 
  createPassword, 
  resetOnboarding 
} from '../../../redux/actions/OnboardingAction';

import './password-setup.scss';

const PasswordSetup = ({
  createPassword,
  createPasswordState: { loading, error, success, data },
  resetOnboarding,
}) => {
  const history = useHistory();
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });
  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
    // Reset onboarding state when component mounts
    resetOnboarding();
  }, [resetOnboarding]);

  useEffect(() => {
    console.log('🔍 PasswordSetup useEffect - success:', success, 'data:', data, 'error:', error);
    
    if (success && data) {
      console.log('✅ Password creation successful!');
      console.log('✅ User data:', data.user);
      console.log('✅ Access token:', data.access_token);
      console.log('✅ Full response data:', data);
      
      // Store tokens and proceed to completion screen
      localStorage.setItem('access', data.access_token);
      localStorage.setItem('refresh', data.refresh_token);
      localStorage.setItem('user_info', JSON.stringify(data.user));
      
      // Clear onboarding session data
      localStorage.removeItem('onboarding_session_id');
      localStorage.removeItem('company_name');
      localStorage.removeItem('support_email');
      
      console.log('✅ Stored tokens and user info in localStorage');
      console.log('✅ Navigating to completion screen...');
      
      // Navigate to completion screen
      history.push('/onboarding/completion');
    } else if (error) {
      console.log('❌ Password creation failed:', error);
    }
  }, [success, data, error, history]);

  const handleSubmit = () => {
    console.log('🔍 PasswordSetup handleSubmit called');
    
    const passwordError = validatePassword(formData.password);
    const confirmPasswordError = validatePasswordMatch(formData.password, formData.confirmPassword);

    const errors = {};
    if (passwordError) errors.password = passwordError;
    if (confirmPasswordError) errors.confirmPassword = confirmPasswordError;

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // Clear any previous errors
    setValidationErrors({});

    const sessionId = localStorage.getItem('onboarding_session_id');
    console.log('🔍 Session ID for password creation:', sessionId);
    
    if (!sessionId) {
      console.error('❌ No session ID found for password creation');
      history.push('/onboarding/company-code');
      return;
    }

    const apiPayload = {
      session_id: sessionId,
      password: formData.password,
      confirm_password: formData.confirmPassword
    };
    
    console.log('🚀 Sending create-password request with payload:', apiPayload);
    createPassword(apiPayload);
  };

  const validatePassword = (password) => {
    if (password.length < 8) {
      return 'Password must be at least 8 characters long';
    }
    return null;
  };

  const validatePasswordMatch = (password, confirmPassword) => {
    if (password !== confirmPassword) {
      return 'Passwords do not match';
    }
    return null;
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData({ ...formData, [name]: value });
    
    // Clear validation errors when user starts typing
    if (validationErrors[name]) {
      setValidationErrors({ ...validationErrors, [name]: null });
    }
  };

  return (
    <div className="password-setup-wrapper">
      <div className="password-setup-form">
        <div className="logo-wrapper">
          <Logo />
        </div>
        
        <StepIndicator currentStep={3} totalSteps={3} />
        
        <div className="heading">Create Your Password</div>
        <div className="subheading">
          Create a secure password for your Peak Mind account
        </div>
        
        {error && (
          <div className="error-wrapper">
            <div>
              <ErrorIcon />
            </div>
            <span>{error}</span>
          </div>
        )}

        <ValidatorForm onSubmit={handleSubmit} className="form">
          <div className="password-field-wrapper">
            <Input
              onChange={handleChange}
              value={formData.password}
              title="Password *"
              placeholder="Enter your password"
              name="password"
              type="password"
              validators={['required']}
              errorMessages={['Password is required']}
              formValid={!validationErrors.password}
              style={{ marginBottom: 16 }}
            />
            {validationErrors.password && (
              <div className="validation-error">{validationErrors.password}</div>
            )}
          </div>


          

          <div className="password-field-wrapper">
            <Input
              onChange={handleChange}
              value={formData.confirmPassword}
              title="Confirm Password *"
              placeholder="Confirm your password"
              name="confirmPassword"
              type="password"
              validators={['required']}
              errorMessages={['Please confirm your password']}
              formValid={!validationErrors.confirmPassword}
              style={{ marginBottom: 16 }}
            />
            {validationErrors.confirmPassword && (
              <div className="validation-error">{validationErrors.confirmPassword}</div>
            )}
          </div>

          <div className="password-help">
            <p>Password must be at least 8 characters long</p>
          </div>

          <div className="action-btn">
          
            <Button type="submit" size="sm" color="blue" loading={loading}>
            Create Password
            </Button>
          </div>
        </ValidatorForm>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  createPasswordState: state.onboarding.createPassword,
});

const mapDispatchToProps = (dispatch) => ({
  createPassword: (details) => {
    dispatch(createPassword(details));
  },
  resetOnboarding: () => {
    dispatch(resetOnboarding());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordSetup);
